module.exports = __webpack_public_path__ + "img/gitlab.1910d641.svg";